import React, { useContext, useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Alert,
  Divider,
} from '@mui/material';
import { UserContext } from '../UserAndProfile/UserContext';
import ReferralInviteForm from './ReferralInviteForm';
import ReferredUsersList from './ReferredUsersList';

interface ReferralCardProps {
  embedded?: boolean;
}

const ReferralCard: React.FC<ReferralCardProps> = ({ embedded = false }) => {
  const { user } = useContext(UserContext);
  const [submitMessage, setSubmitMessage] = useState<{
    type: 'success' | 'error';
    message: string;
  } | null>(null);

  const referredUsers = user?.referredUsers || [];
  const referralsCount = referredUsers.length;
  const activeReferrals = referredUsers.filter(r => r.referralStatus === 'active').length; //9/26/2025: previously had 'signed_up' in the filter, but I don't think it's necessary since I removed it from the data type. 

  const content = (
    <Box sx={{ flex: 1 }}>
      {/* Header */}
      <Box sx={{ mb: 2 }}>
        {/*<Typography variant="h6" component="h2" color="primary.main" gutterBottom>
          Refer Friends
        </Typography>*/}
        <Typography variant="body2" color="text.secondary">
          {referralsCount === 0 ?
            user?.userRole === "student" ? "Invite your parent to join and follow your progress + invite your friends!" 
            :  "Invite a friend, neighbor, or colleague to try Next Step SAT Prep!"
              : `${referralsCount} invitation${referralsCount !== 1 ? 's' : ''} sent${activeReferrals > 0 ? `, ${activeReferrals} signed up` 
              : ''}`
          }
          
        </Typography>
      </Box>

      {/* Success/Error Messages */}
      {submitMessage && (
        <Alert 
          severity={submitMessage.type} 
          sx={{ mb: 2 }}
          onClose={() => setSubmitMessage(null)}
        >
          {submitMessage.message}
        </Alert>
      )}

      {/* Invitation Form */}
      <ReferralInviteForm 
        onSuccess={(message: string) => setSubmitMessage({ type: 'success', message })}
        onError={(message: string) => setSubmitMessage({ type: 'error', message })}
      />

      {/* Referred Users List */}
      {referralsCount > 0 && (
        <>
          <Divider sx={{ my: 1 }} />
          <ReferredUsersList referredUsers={referredUsers} />
        </>
      )}
    </Box>
  );

  if (embedded) {
    return content;
  }

  return (
    <Card sx={{ 
      height: 'fit-content',
      minHeight: '250px',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <CardContent sx={{ flex: 1 }}>
        {content}
      </CardContent>
    </Card>
  );
};

export default ReferralCard; 